import React from 'react'

import Footer from 'client/components/Footer'
import ForgotPasswordForm from 'src/comps/FormForgotPassword'
import Head from 'client/pages/Home/Head'
import Header from 'client/components/Header'
import Page from 'src/comps/Page'

import styles from 'src/pages/forgot-password/styles.module.css'
import { getServerSideProps as getServerSidePropsHandler } from 'src/pages/forgot-password/server'
import { ConfigType } from 'src/types/config'
import { ListOfAncillary } from '@s4l/stayforlong/booking/ListOfAncillary'

const pageId = 'forgotPassword'

interface IForgotPasswordPage {
  config: ConfigType
  ancillariesJSON: ReturnType<ListOfAncillary['toJSON']>
}

const ForgotPasswordPage = ({ config, ancillariesJSON }: IForgotPasswordPage) => {
  return (
    <Page config={config} pageId={pageId} disableOAuth>
      <Head />
      <Header pageId={pageId} hasLogin={false} backButton ancillariesJSON={ancillariesJSON} />

      <section className={styles.section}>
        <ForgotPasswordForm />
      </section>

      <Footer />
    </Page>
  )
}

export const getServerSideProps = getServerSidePropsHandler

ForgotPasswordPage.pageId = pageId
ForgotPasswordPage.pagePathView = '/forgot-password'

export default ForgotPasswordPage
